var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoverBc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.1626 24H59V43.2857H86L76.1626 24Z",
    fill: "#FDE8F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3333 8V40.8667H88V66H5V8H60.3333Z",
    fill: "#EC187B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61 24H76.1626L86 43.2857",
    stroke: "#EC187B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 72.5C34.5 77.4467 30.2712 81.5 25 81.5C19.7288 81.5 15.5 77.4467 15.5 72.5C15.5 67.5533 19.7288 63.5 25 63.5C30.2712 63.5 34.5 67.5533 34.5 72.5Z",
    fill: "#FDE8F2",
    stroke: "#EC187B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5 72.5C79.5 77.4467 75.2712 81.5 70 81.5C64.7288 81.5 60.5 77.4467 60.5 72.5C60.5 67.5533 64.7288 63.5 70 63.5C75.2712 63.5 79.5 67.5533 79.5 72.5Z",
    fill: "#FDE8F2",
    stroke: "#EC187B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 18H43",
    stroke: "#EC187B",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 26L25 26",
    stroke: "#EC187B",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3 33L13 33",
    stroke: "#EC187B",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5 18H43M5 26H25M5 33H13",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverBc);
export default __webpack_public_path__ + "static/media/hoverBC.eb524866df6d848fc73891bcb6782d2b.svg";
export { ForwardRef as ReactComponent };